import React, { useState } from "react";

//import { ActionMeta, SingleValue, MultiValue } from "react-select"


import Masonry from "react-responsive-masonry"

//import Masonry from 'masonry-layout';


import { Modal, Button, Space, Text } from '@mantine/core';

import styles from './photo-pack.module.scss'

import { Photo, SubscriberLevel, UserInformation } from '../../lib/definitions';
import useAuth from "../../lib/useAuth";
import Link from "next/link";

import { AspectBox } from "../../components/AspectBox";
import { GetServerSideProps } from "next";
import { MenuId } from "../../components/Header";
import Layout from "../../components/Layout";
import { getUserInformation, getJWTTokenFromUser } from "../../lib/data";
import axios from "axios";
import Head from "next/head";
import { modals } from "@mantine/modals";
import { getClerkHeader } from "../../lib/common";
import { getAuth } from '@clerk/nextjs/server';

type Data = {
  images: Photo [],
  name: string,
  description: string
    }


export default function PhotoPackPage(props: {data: Data})
{

    const data = props.data;

    
    return(
    
    <>

    
  <Layout menuId={MenuId.imageSearch} hidePopUp>
  <Head>
      <title>{data.name}</title>
      <meta name="description" content={data.description}/>


  </Head>

  <div className = {styles.mainContent}>
  <h1 className={styles.h1}>{data.name}</h1>
  <Text mb='sm' ta='center'>{data.description}</Text>
  <Footer/>
      <Space h ='sm'/>
   <PhotoList photos={data.images}/>
    <Space h ='sm'/>

        <Footer/>
    </div>
 <Space h ='sm'/>

</Layout></>
  );


}    

function Footer()
{
    const {userInformation}=useAuth();
    const canAccess = canAccessImages(userInformation);
    const copyright = <Text mt='sm' ta="center">To access all the images, please <Link href="/log-in">log on</Link> or <Link href="/raw-umber-subscription/">purchase a subscription</Link></Text>

    return <><Text ta='center'>You may use these photographs for drawing, painting and sculpting from. You may share or sell your work. <strong>You may not, however, distribute the original images or use them for any other purposes.</strong> The copyright of the photograph remains with the photographer.</Text>
      <Text mt='sm' ta='center'>To see more images, check out our <Link href='/image-search'>searchable image reference library</Link></Text>
        {!canAccess && copyright}
      </>
      

}

function canAccessImages(ui: UserInformation | undefined)
{
    return ui?.subscribed && (ui?.subscriber_level==SubscriberLevel.gold || ui?.subscriber_level==SubscriberLevel.image);
}



interface LightboxModalProps {
    photo: Photo | null;
    open: boolean,
    onClose: ()=>void
}


function LightboxModal(props: LightboxModalProps) 
{

    if (props.photo == null) {
        return <></>;
    }


    let file = props.photo.imageFile;
    let img = <div className={styles.lightboxImageBoundingBox}><img src={file} /></div>;

    let ar = 1;

    if (props.photo.width > 0 && props.photo.height > 0) {
        ar = props.photo.width / props.photo.height;
    }

    let copyright = <div className={styles.lightboxCopyright}>You may use this photograph for drawing, painting and sculpting from. You may share or sell your work. <strong>You may not, however, distribute the original images or use them for any other purposes.</strong> The copyright of the photograph remains with the photographer. </div>;
    let footer = <div className={styles.lightboxFooter}><Button onClick={props.onClose}>Close</Button></div>
    let more = !!props.photo.modelId && <>, or view other photographs of this model <a href={`/image-search?model=${props.photo.modelId}`}>here</a></>
    let download = <div className={styles.lightboxDownload}>You can <a href={props.photo.extraLargeFile}>download a high resolution photo from here</a>{more}</div>
    let credit = props.photo.credit && <div className={styles.credit}>{props.photo.credit}</div>

    return (<Modal onClose={props.onClose} fullScreen opened={props.open}><div className={styles.lightbox}>
        {img}{credit}{copyright}{download}{footer}</div>
        </Modal>);

}



interface TileProps {
    photo: Photo,
    showLightBox: (_: Photo)=>void;
}


function Tile(tprops: TileProps) {

    const {userInformation}=useAuth();


    let ar = 1;

    if (tprops.photo.thumbnailWidth > 0 && tprops.photo.thumbnailHeight > 0) {
        {
            ar = tprops.photo.thumbnailWidth / tprops.photo.thumbnailHeight;
        }
    }

    let file = tprops.photo.thumbnailFile;

    let width = tprops.photo.thumbnailWidth;
    let height = tprops.photo.thumbnailHeight;

    /*if (tprops.photo.id==33743)
    {
        console.log(width);
        console.log(height);
    }*/
    //let rotation="0deg";
    let swap = false;

    switch (tprops.photo.orientation)
    {
        case 5:
            //rotation="90deg";
            swap = true;
            break;
        case 6:
           // rotation="90deg";
            swap = true;
            break;
        case 7:
            //rotation="-90deg";
            swap = true;
            break;
        case 8:
           // rotation="-90deg";
            swap = true;
            break;
    }

    /*if (swap)
    {
        let t = width;
        width = height;
        height = t;
    }*/

    const canAccess = canAccessImages(userInformation) || tprops.photo.isFree;
      
    if (!canAccess) {
        file = tprops.photo.pixelatedFile;
    }
    return (
        <AspectBox width= {width} height ={height}>
            <div className={styles.tile}>
                {/*eslint-disable-next-line @next/next/no-img-element*/}
                <img alt = "Photograph" src={file} width="100%" onClick={()=>
                    {
                        if (canAccess)
                        {
                            tprops.showLightBox(tprops.photo)
                        }
                        else
                        {
                             const copyright = <div>To access this image, please <Link href="/log-in">log on</Link> or <Link href="/raw-umber-subscription/">purchase a subscription</Link></div>
                               modals.open({
                                           title: 'Image library',
                                           children: <>
                                           {copyright}
                                           <Button fullWidth onClick={(e)=> {modals.closeAll();}} mt="md">
                                                     Ok
                                                   </Button>
                                           </>
                                   
                                           
                                           });

                        }
                    }} />
            </div>
            </AspectBox>
    );
};


function PhotoList(props: {photos: Photo []}) {

    const [selectedPhoto, setSelectedPhoto]=useState<Photo | null>(null);
    const [showModal, setShowModal]=useState(false);

    let masonry = <div></div>

    if (props.photos != null && props.photos.length != 0) {

        masonry = /*<ResponsiveMasonry columnsCountBreakPoints={breakPoints}>*/
            <><Masonry>
            {props.photos.map(x => (
                <Tile key={x.id} photo={x} showLightBox={()=>{setSelectedPhoto(x); setShowModal(true);}}/>))}

        </Masonry>
        <LightboxModal photo={selectedPhoto} open={showModal} onClose={()=>setShowModal(false)}/>
        </>

    }

    return (masonry);
}

export const getServerSideProps : GetServerSideProps = async (context)=>
{



    let user = await getUserInformation(context.req);
    let token = null;
               
    const { getToken } = getAuth(context.req);
    const clerkToken = await getToken();

    
    if (user.subscribed)
                {
                    token = await getJWTTokenFromUser(user);
                }
                

        let options = { 
        method: 'GET',  cache: "no-store" as RequestCache,
        headers: {
            ... token?{'auth-token': token}:{}, 
            ...getClerkHeader(clerkToken)}
        };

                
    let url = process.env.ADMIN_ROUTE + '/imagepack/' + context.params?.id;

    try
    {

        let at2 =  await axios.get(url, options);
        const result = at2.data;
        //console.log(result);

        return {
        props: {
            data: 
            { 
                images: result.photos,
                name:result.name,
                description: result.description
            }
            }
        }
    }
    catch (err:any)
    {
    if (axios.isAxiosError(err) && err.response?.status === 404) {
        
         return {
                notFound: true
            } 
        }
        throw err;
    }
}